export default __webpack_public_path__ + "static/media/tactor_connect-24px-grey.87fedb81.svg";